module.exports = "/_next/static/pages/test-guidelines/4ea20f536f53e59a616569b16e976c7e.png";